import React, { Component } from "react";
import { List, Segment } from "semantic-ui-react";

import EntityUserItem from "./Items/EntityUserItem";
import Pagination from "../../utils/Pagination";

const styles = {
  listItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  font: {
    fontSize: "16px",
    fontWeight: "bold",
  },
};

const options = [
  { key: "1", text: "10 por página", value: 10 },
  { key: "2", text: "20 por página", value: 20 },
  { key: "3", text: "50 por página", value: 50 },
  { key: "4", text: "100 por página", value: 100 },
];

export class EntityUserList extends Component {
  state = { paginatedItems: [], itemsPerPage: 10 };

  onChangePage = (e) => {
    this.setState({
      paginatedItems: e,
    });
  };

  render() {
    const { entityUsers } = this.props;
    // console.log(entityUsers);
    const { paginatedItems, itemsPerPage } = this.state;
    let listItems = [];
    listItems = paginatedItems.map((item, index) => {
      return (
        <EntityUserItem
          // showEditEntityForm={this.props.showEditEntityForm}
          // selectedEntity={this.props.selectedEntity}
          clearEntityInfo={this.props.clearEntityInfo}
          handleDeleteEntityUser={this.props.handleDeleteEntityUser}
          handleApproveEntityUser={this.props.handleApproveEntityUser}
          item={item}
          key={index}
        />
      );
    });
    return (
      <React.Fragment>
        {entityUsers.length > 0 ? (
          <Segment className="listAlign">
            <List verticalAlign="middle" divided size="large">
              <List.Item className="listItemPadding">
                <List.Content verticalAlign="middle">
                  <div style={styles.listItem}>
                    <label style={styles.font}>Usuario</label>
                    <div>
                      <label style={styles.font} className="labelAlign">
                        Habilitar
                      </label>
                      <label style={styles.font} className="labelAlign">
                        Borrar
                      </label>
                    </div>
                  </div>
                </List.Content>
              </List.Item>

              {listItems}
            </List>
            <Pagination
              items={entityUsers}
              itemsPerPage={itemsPerPage}
              onChangePage={this.onChangePage}
              options={options}
            />
          </Segment>
        ) : null}
      </React.Fragment>
    );
  }
}

export default EntityUserList;
